import { jsx as _jsx } from "react/jsx-runtime";
import { Stack, Fieldset as XenFieldset } from 'xen-ui';
export const Fieldset = ({ children, gap = 'lg', ...rest }) => {
    return (_jsx(XenFieldset, { styles: (theme) => ({ legend: { fontWeight: 'bold', fontSize: theme.fontSizes.md } }), variant: "filled", ...rest, children: _jsx(Stack, { gap: gap, children: children }) }));
};
